import { render, staticRenderFns } from "./CustomerSatisfaction.vue?vue&type=template&id=164aebee&scoped=true&"
import script from "./CustomerSatisfaction.vue?vue&type=script&lang=js&"
export * from "./CustomerSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSatisfaction.vue?vue&type=style&index=0&id=164aebee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164aebee",
  null
  
)

export default component.exports